import { render, staticRenderFns } from "./Correspondences.vue?vue&type=template&id=16bae25e&scoped=true&"
import script from "./Correspondences.vue?vue&type=script&lang=js&"
export * from "./Correspondences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bae25e",
  null
  
)

export default component.exports